var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1460,
    height: 255,
    viewBox: "0 0 1460 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_6610)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1460,
    height: 255,
    fill: "#28D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.628 -46.304C177.868 -17.9029 189.66 17.6974 187.812 53.8792C185.964 90.0611 170.602 124.363 144.581 150.408C118.561 176.454 83.6519 192.471 46.344 195.483C9.03606 198.494 -28.1329 188.295 -58.2535 166.781L-20.7294 117.59C-2.92709 130.306 19.041 136.334 41.0912 134.554C63.1415 132.774 83.7738 123.307 99.1528 107.913C114.532 92.5196 123.611 72.2461 124.703 50.8614C125.796 29.4768 118.826 8.43578 105.091 -8.35022L154.628 -46.304Z",
    fill: "url(#paint0_linear_534_6610)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.87 19.6674C1417.51 -13.7114 1484.97 2.8316 1512 15.2754L1509.4 103.847C1494.5 98.2349 1458.78 87.011 1435.08 87.011C1405.45 87.011 1362.32 111.899 1332.69 144.838C1303.07 177.778 1268.24 231.213 1251.09 254.637C1237.37 273.376 1214.19 300.02 1204.32 311H1038C1160.66 300.02 1261.49 113.363 1273.96 99.4549C1286.43 85.5471 1296.83 61.3908 1363.87 19.6674Z",
    fill: "url(#paint1_linear_534_6610)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 219.5C253 308.694 180.694 381 91.5 381C2.30602 381 -70 308.694 -70 219.5C-70 130.306 2.30602 58 91.5 58C180.694 58 253 130.306 253 219.5Z",
    fill: "url(#paint2_linear_534_6610)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563 50.5C1563 144.112 1487.11 220 1393.5 220C1299.89 220 1224 144.112 1224 50.5C1224 -43.1123 1299.89 -119 1393.5 -119C1487.11 -119 1563 -43.1123 1563 50.5Z",
    fill: "url(#paint3_linear_534_6610)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 317.5C746 411.112 670.112 487 576.5 487C482.888 487 407 411.112 407 317.5C407 223.888 482.888 148 576.5 148C670.112 148 746 223.888 746 317.5Z",
    fill: "url(#paint4_linear_534_6610)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091 -62.5C1091 31.1123 1015.11 107 921.5 107C827.888 107 752 31.1123 752 -62.5C752 -156.112 827.888 -232 921.5 -232C1015.11 -232 1091 -156.112 1091 -62.5Z",
    fill: "url(#paint5_linear_534_6610)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_534_6610",
    x1: 192.27,
    y1: -150.861,
    x2: -46.1601,
    y2: 265.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F0FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#DDFFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_534_6610",
    x1: 1518.55,
    y1: -49.7821,
    x2: 1324.51,
    y2: 449.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F0FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#DDFFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_534_6610",
    x1: -198.086,
    y1: -31.846,
    x2: 503.975,
    y2: 682.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110054,
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367414,
    stopColor: "#F3F3F3",
    stopOpacity: 0.510417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748288,
    stopColor: "#28D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_534_6610",
    x1: 1089.57,
    y1: -213.297,
    x2: 1826.41,
    y2: 536.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110054,
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367414,
    stopColor: "#F3F3F3",
    stopOpacity: 0.510417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748288,
    stopColor: "#28D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_534_6610",
    x1: 272.569,
    y1: 53.7035,
    x2: 1009.41,
    y2: 803.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110054,
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367414,
    stopColor: "#F3F3F3",
    stopOpacity: 0.510417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748288,
    stopColor: "#28D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_534_6610",
    x1: 617.569,
    y1: -326.297,
    x2: 1354.41,
    y2: 423.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110054,
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367414,
    stopColor: "#F3F3F3",
    stopOpacity: 0.510417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748288,
    stopColor: "#28D1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_6610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1460,
    height: 255,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHead);
export default __webpack_public_path__ + "static/media/contentHead.6653a3575561e7520cb6ff5396b39578.svg";
export { ForwardRef as ReactComponent };